var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useTheme } from "styled-components";
import { Icon } from "../../icon";
import { Typo } from "../../typography";
import { ChipContainer, IconWrapper, TitleWrapper } from "./chip.styles";
export const Chip = (_a) => {
    var { title, icon, type, disabled, selected, value, chipMinWidth, gap, isShowLabel, onChange } = _a, restProps = __rest(_a, ["title", "icon", "type", "disabled", "selected", "value", "chipMinWidth", "gap", "isShowLabel", "onChange"]);
    const theme = useTheme();
    const [focused, setFocused] = useState(false);
    let symbol;
    if (type === "A") {
        symbol = "Close";
    }
    else {
        symbol = icon;
    }
    const valueContainer = (_jsxs(Typo, Object.assign({ variant: "p2", fontWeight: theme.fontWeights.medium }, { children: [title, ":"] })));
    return (_jsxs(ChipContainer, Object.assign({}, restProps, { onMouseDown: () => setFocused(false), onKeyUp: (event) => {
            if (!disabled) {
                if (event.key === "Enter" ||
                    event.key === "Space" ||
                    event.key === " ") {
                    onChange(value);
                }
            }
            setFocused(true);
        }, onBlur: () => setFocused(false), focused: focused, type: type, disabled: disabled, selected: selected, tabIndex: disabled ? -1 : 0, chipMinWidth: chipMinWidth, gap: gap, onClick: () => {
            onChange(value);
        }, "data-testid": "chip-input" }, { children: [_jsxs(TitleWrapper, Object.assign({ isShowLabel: isShowLabel }, { children: [type === "A" && isShowLabel ? valueContainer : "", _jsx(Typo, Object.assign({ variant: "p2", fontWeight: type === "A" ? theme.fontWeights.regular : theme.fontWeights.medium }, { children: value }))] })), _jsx(IconWrapper, { children: _jsx(Icon, { symbol: symbol }) })] })));
};
